export default {
  title: 'Garantii clienti',
  table: {
    client_id: 'Id MB',
    client_name: 'Nume Client',
    client_identifier: 'Cod Client',
    available_amount: 'Valoare garantie initiala',
    mb_consumed_amount: 'Valoare comenzi MB',
    diff: 'Valoare garantie disponibila',
    invoice_amount: 'Valoare comenzi BOU',
    notification_percent: 'Notificare client la procent din garantie',
    updated_at: 'Data actualizare'
  },
  buttons: {
    import: 'Incarca import',
    export: 'Exporta'
  }
}
